import {Component, Input, OnInit} from '@angular/core';
import {PlayersService} from "../../../../services/players.service";
import {
  availableGridTypesResponse,
  TournamentTunerMethodsService
} from "../../../../services/tournament-tuner-methods.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-ordinary-grid-types-list',
  templateUrl: './ordinary-grid-types-list.component.html',
  styleUrls: ['./ordinary-grid-types-list.component.scss']
})
export class OrdinaryGridTypesListComponent implements OnInit {

  private _tournamentId;
  private _doubleEliminationGridPattern: string = 'de1';
  private _maximalAmountOfPlayers: number;
  private _doubleEliminationsMap: Map<string, number> = new Map<string, number>();

  constructor(
    private playersService: PlayersService,
    private tournamentTunerService: TournamentTunerMethodsService,
    private activeModal: NgbActiveModal,
  ) {

  }

  ngOnInit(): void {
    this._tournamentId = this.tournamentTunerService.tournamentId;
    const playersLeavingGroupsNumber = this.tournamentTunerService.playersLeavingGroupNumber;
    const groupsAmount = this.tournamentTunerService.groupsAmount;
    const argsList = {
      conventional: [
        this._tournamentId,
      ],
      withGroups: [
        this._tournamentId,
        playersLeavingGroupsNumber,
        groupsAmount,
      ]
    };


    this.tournamentTunerService.getAvailableGridTypesList(
      // @ts-ignore
      ...argsList[this.tournamentTunerService.chosenTournamentType],
    )
      .subscribe((response: availableGridTypesResponse) => {
        this.maximalAmountOfPlayers = response.max_player_count;

        this.initializeDoubleEliminationsMap(
          this.maximalAmountOfPlayers,
          response.enable_bracket_types.filter(gridType => gridType.startsWith(this._doubleEliminationGridPattern))
        );
      });
  }

  get maximalAmountOfPlayers() {
    return this._maximalAmountOfPlayers;
  }

  set maximalAmountOfPlayers(value) {
    this._maximalAmountOfPlayers = value;
  }

  get doubleEliminationsMap() : Map<string, number> {
    return  this._doubleEliminationsMap;
  }

  initializeDoubleEliminationsMap(maxNumberOfPlayers: number, listOfDoubleEliminations: string[]) {
    const gridChar = (inputString: string) => parseInt(inputString.split(this._doubleEliminationGridPattern).pop());

    listOfDoubleEliminations.forEach((gridType) => {
      this.doubleEliminationsMap.set(gridType, maxNumberOfPlayers / gridChar(gridType));
    });

  }

  gridTypeClickHandler($event) {
    const gridType = $event.target.id;
    const locationsDict = {
      conventional: '/bracket',
      withGroups: '/groups',
    }
    this.tournamentTunerService.gridTypeClickHandler(gridType).subscribe(() => {
      window.location.href =
        window.location.href.replace('/players', locationsDict[this.tournamentTunerService.chosenTournamentType]);
    });
  }

}
